import {Outlet} from "react-router-dom";
import MuiContainer from '@mui/material/Container';
import Header from "layout/Header";
import Footer from "./Footer";

const Container = () => {
  return (
    <MuiContainer sx={(theme) => ({
      [theme.breakpoints.down('lg')]: {
        p: 0
      }
    })}>
      <Header />
      <Outlet />
      <Footer />
    </MuiContainer>
  )
}

export default Container;
